<style scoped lang="scss">
  .strengths{
    display: flex;
    margin-top: 30px;
    li{
      flex:1;
      text-align: center;
      border-right: 1px solid #eee;
      padding:0 40px;
      &:last-child{
        border: 0;
      }
      h4{
        font-size: 18px;
        margin-bottom: 10px;
        color:#014492;
      }
    }
  }
  .download{
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #E4E6EA;
    li{
      width:50%;
      padding:20px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
      font-size: 16px;
      cursor: pointer;
      &:nth-of-type(1){
        border-top: 1px solid #E4E6EA;
      }
      &:nth-of-type(2){
        border-top: 1px solid #E4E6EA;
      }
      &:hover{
        color:#014492;
      }
    }
    .btn-primary{
      font-size: 14px;
      span{
        margin-right: 7px;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
      }
    }
  }
  .c-title small{
    margin-top: 10px;
  }
  .desc{
    font-size: 16px;
  }

  .xing_1{
    display: flex;
    overflow: auto;
    justify-content: space-between;
    flex-wrap: wrap;
    li{
      height: 312px;
      width: 380px;
      //margin-right: 30px;
      .img{
        width: 123px;
        padding-top: 43px;
        padding-bottom: 45px;
        margin-left: auto;
        margin-right: auto;
      }
      p{
        font-size: 20px;
        color:#fff;
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
      }
    }
    li:last-child{
      margin-right: 0;
    }
    .xingcheng1{
      overflow: auto;
      background: url("../../assets/img/gene.jpg") no-repeat;
      background-size:auto;
    }
    .xingcheng2{
      overflow: auto;
      background: url("../../assets/img/life.jpg") no-repeat;
      background-size:auto;
    }
    .xingcheng3{
      overflow: auto;
      background: url("../../assets/img/biology.jpg") no-repeat;
      background-size:auto;
    }
    //鼠标移入后
    .xingcheng1:hover{
      overflow: auto;
      cursor: pointer;
      background: url("../../assets/img/gene1.jpg") no-repeat;
      background-size:auto;
    }
    .xingcheng2:hover{
      overflow: auto;
      cursor: pointer;
      background: url("../../assets/img/life1.jpg") no-repeat;
      background-size:auto;
    }
    .xingcheng3:hover{
      overflow: auto;
      cursor: pointer;
      background: url("../../assets/img/biology1.jpg") no-repeat;
      background-size:auto;
    }
  }
  .cons{
    display: none;
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .container100{
      margin-bottom: 20px!important;
    }
    .cons .xing_1{
      display: block!important;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .cons .xing_1 li {
      margin-bottom: 10px;
      width: 320px !important;
      margin-right: 0 !important;
      height: 200px !important;
    }
    .cons .xing_1 li .img {
      width: 70px !important;
    }
    .cons .xing_1 li:last-child {
      margin-bottom: 0;
    }
    .cons .xing_1 li .img {
      padding-top: 35px !important;
      padding-bottom: 35px !important;
    }
    .cons .xing_1 .xingcheng1:hover{
      background: url("../../assets/img/life.jpg") no-repeat!important;
    }
    .cons .xing_1 .xingcheng2:hover{
      background: url("../../assets/img/biology.jpg") no-repeat!important;
    }
    .cons .xing_1 .xingcheng3:hover{
      background: url("../../assets/img/gene.jpg") no-repeat!important;
    }
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner con">
      <img src="@/assets/img/生物制造/banner.png" class="img-fluid" title="生物制造CXO" alt="擎科生物-生物制造CXO服务">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <img src="@/assets/img/研究领域banner/生物制造.jpg" class="img-fluid" title="生物制造CXO" alt="擎科生物-生物制造CXO服务">
      <div class="info"></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container container100" style="margin-bottom: 100px;">
      <p class="desc">擎科生物未来将打造生物制造CXO服务，包含生物医药产品、生物化学产品、生物精细化学品、生物农业产品和大健康产品等，全方位致力于小分子药物及生物制剂生产等生物药品领域，助力药企生产。随着药物研发从化学药时代逐渐进入生物药时代，单抗、细胞治疗、基因治疗等研发方向将占据更重要的位置。擎科生物依托现有的<a href="/tec/gen_compose" style="color:#014492;font-weight:bold;">基因合成</a>全产业链、<a href="/equipment/life_sciences" style="color:#014492;font-weight:bold;">生命科学设备及原料</a>将开启生物制造CXO服务新篇章。精彩产品，敬请期待！</p>
        <div class="con" @click="() => $router.push('/gene-factory')" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;margin-top: 30px;"><img src="@/assets/img/生物制造/插图.png" alt="擎科生物-生物医药产品、生物化学产品、生物精细化学品、生物农业产品和大健康产品等"></div>
        <div class="cons gene_img" @click="() => $router.push('/gene-factory')"><img src="@/assets/img/生物制造/插图.png" alt="擎科生物-生物医药产品、生物化学产品、生物精细化学品、生物农业产品和大健康产品等"></div>
      </div>
        <div class="c-title">资源中心<small>Resource Center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      <div class="container">
        <div class="c-title">相关研究领域<small>Related Research Fields</small></div>
        <div class="con">
          <ul class="xing_1">
            <li class="xingcheng1" @click="$router.push('/products/Products1')">
              <div class="img"><img src="@/assets/img/gene.png" width="100%" alt="擎科生物-合成基因组学产品及服务"></div>
              <p>合成基因组学产品及服务</p>
            </li>
            <li class="xingcheng2" @click="$router.push('/equipment/life_sciences')">
              <div class="img"><img src="@/assets/img/life.png" width="100%" alt="擎科生物-生命科学研究设备及原料"></div>
              <p>生命科学研究设备及原料</p>
            </li>
            <li class="xingcheng3" @click="$router.push('/Biological_manufacturing/Biological')">
              <div class="img"><img src="@/assets/img/biology.png" width="100%" alt="擎科生物-生物制造CXO"></div>
              <p>生物制造CXO</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px; ">
          <ul class="xing_1">
            <li class="xingcheng1" @click="$router.push('/products/Products1')">
              <div class="img"><img src="@/assets/img/gene.png" width="100%" alt="擎科生物-合成基因组学产品及服务"></div>
              <p>合成基因组学产品及服务</p>
            </li>
            <li class="xingcheng2" @click="$router.push('/equipment/life_sciences')">
              <div class="img"><img src="@/assets/img/life.png" width="100%" alt="擎科生物-生命科学研究设备及原料"></div>
              <p>生命科学研究设备及原料</p>
            </li>
            <li class="xingcheng3" @click="$router.push('/Biological_manufacturing/Biological')">
              <div class="img"><img src="@/assets/img/biology.png" width="100%" alt="擎科生物-生物制造CXO"></div>
              <p>生物制造CXO</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      gene2: [
        {name: '修饰合成',img: '1', ref: '/tec/compose1'},
        {name: '仪器设备', img: '2',ref: '/tec/gen_compose'},
        // {name: '生物试剂',img: '3', ref: '/equipment/Molecular_reagent'},
        {name: '化学试剂',img: '4', ref: '/sanger'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/Biological_manufacturing/Biological.vue